// extracted by mini-css-extract-plugin
module.exports = {"attitudes-cell":"_21yCY","attitudes-cell_exp":"_1dQnR","attitudes-cell_attitudes":"_1Wlzg"};